import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M17 7A5 5 0 1 1 7 7a5 5 0 0 1 10 0Zm-2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8.14 14.506c-1.28.306-2.62.765-4.015 1.377a3.794 3.794 0 0 0-1.531 1.254c-.396.55-.594 1.214-.594 1.989v2.876h20v-2.876c0-.775-.197-1.437-.59-1.984a3.758 3.758 0 0 0-1.569-1.253 26.53 26.53 0 0 0-3.997-1.368A15.868 15.868 0 0 0 12 14.047c-1.292 0-2.578.153-3.86.459ZM4 20.002v-.876c0-.419.1-.658.218-.822.187-.26.42-.454.726-.597 1.297-.567 2.517-.983 3.661-1.256A14.565 14.565 0 0 1 12 16.047c1.127 0 2.246.137 3.36.415a24.51 24.51 0 0 1 3.683 1.26c.34.152.571.348.743.587.113.158.214.396.214.817v.876H4Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }